// @ts-nocheck
import { adjustmentService } from '@/services';
import StoreAdjustmentVM from '@/view-model/store-adjustment/StoreAdjustmentVM';
export default {
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    setSortOption({ commit }, payload) {
        commit('SET_SORT_OPTION', payload);
    },
    /**
     * 상점정산 내역 호출
     */
    async getStoreAdjustment({ state: { filterOption, sortOption, }, getters, commit, }, payload) {
        const { pageNumber, pageSize, searchWord, } = filterOption;
        const [fromAt, toAt,] = getters.getterSelectedMonthToTimeStamp;
        try {
            const param = {
                pageNumber,
                pageSize,
                fromAt,
                toAt,
                sortOption,
                storeName: undefined,
            };
            if (searchWord.value) {
                param.storeName = searchWord.value;
            }
            const all = await Promise.all([
                adjustmentService.getStoreAdjustment(payload.hubId, param),
            ]);
            const data = all[0];
            data.list = data.list.map((store) => new StoreAdjustmentVM(store));
            commit('GET_STORE_ADJUSTMENT_LIST', data);
            return true;
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            console.log('[getStoreAdjustment] ', message);
            commit('RESET_STORE_ADJUSTMENT_LIST');
            return {
                message,
            };
        }
    },
    resetStoreAdjustment({ commit }) {
        commit('RESET_STORE_ADJUSTMENT_LIST');
    },
};
